import { ReactElement } from "react";
import { ReactLocation, MakeGenerics } from "react-location";
import { parseSearch, stringifySearch } from "utils/jsurl";

export type LocationGenerics = MakeGenerics<{
  Search: {
    redirect?: string;
    fromDate?: string;
    toDate?: string;
    page?: number;
    pageSize?: number;
    search?: string;
    searchField?: string;
    minSearch?: number;
    sort?: string;
    status: string;
    modal?:
    "create"
    | "update"
    | "updateIdentity"
    | "updateLocation"
    | "updateTariff"
    | "update"
    | "view"
    | "viewComplaint"
    | "view-feedback"
    | "viewBulk"
    | "configure"
    | "calculate"
    | "assign"
    | "schedule"
    | "send"
    | "resolve"
    | "approve"
    | "disapprove"
    | "reject"
    | "reassign"
    | "expand"
    | "goto"
    | "clone"
    | "investigate"
    | "suspend"
    | "restore"
    | "ticket"
    | "submit"
    | "terminate"
    | "delete"
    | "enable"
    | "disable"
    | "lock"
    | "unlock"
    | "complete"
    | "cancel"
    | "correct"
    | "reset"
    | "scrap"
    | "refurbish"
    | "reship"
    | "view-order"
    | "regularization"
    | "simulator"
    | "view-initiation"
    | "upload"
    | "generate"
    | "escalate";
    id?: string;
    region?: string;
    district?: string;
    block?: string;
    round?: string;
    plot?: string;
    itinerary?: string;
    property?: string;
    role?: "SuperAdmin" | "Admin" | "Supervisor" | "Reader";
    month?: number;
    year?: number;
    tariffClass?: string;
    customerType?: string;
    serviceType?: string;
    serviceClass?: string;
    view?: "day" | "week" | "month" | "quarter" | "year" | "custom";
    orderStatus?: string;
    orderType?: string;
    token?: string;
    brand?: string;
    model?: string;
    location?: string;
    section?: string;
    origin?: string;
    source?: string;
  };
  Params: {
    id?: string
    region?: string;
    district?: string;
    block?: string;
    round?: string;
    plot?: string;
    itinerary?: string;
    tariffClass?: string;
    readingSet?: string;
    serviceRequest?: string;
    serviceRegularization?: string;
    servicePoint?: string;
    complaint?: string;
  };
  RouteMeta: {
    layout?: "App" | "Auth";
    breadcrumb: (params: LocationGenerics["Params"]) => ReactElement;
    section?: "General" | "Structure" | "Configuration" | "Users & Profiles";
  };
}>;

const location = new ReactLocation({
  parseSearch,
  stringifySearch,
});

export default location;
